import { useMutation } from "@apollo/client";
import { Field, FinalFormInput } from "@comet/admin";
import Form from "@src/components/Form";
import {
    type GQLCameraAdminQuery,
    type GQLCreateActivityAdminMutation,
    type GQLCreateActivityAdminMutationVariables,
    type GQLCreateActivityInput,
} from "@src/graphql.generated";
import { useUser } from "@vivid/react-oidc-client";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

// eslint-disable-next-line @comet/no-private-sibling-import
import { createActivityMutation } from "./ActivityLog.gql";
import FormButtons from "./FormButtons";

interface AddFormProps extends GQLCameraAdminQuery {
    handleClose: () => void;
}

const AddForm: FC<PropsWithChildren<AddFormProps>> = ({ cameraAdmin, handleClose }) => {
    const intl = useIntl();
    const [createMutation] = useMutation<GQLCreateActivityAdminMutation, GQLCreateActivityAdminMutationVariables>(createActivityMutation);
    const user = useUser();

    const submit = ({ message }: GQLCreateActivityInput) =>
        createMutation({
            variables: {
                input: {
                    message,
                    createdBy: `${user?.given_name} ${user?.family_name}`,
                    cameraId: cameraAdmin.id,
                },
            },
            refetchQueries: ["ActivitiesAdmin"],
        });

    return (
        <Form
            mode="add"
            onSubmit={submit}
            title={intl.formatMessage({ id: "reviermanager.devices.form.activityLog.add", defaultMessage: "Neue Aktivität" })}
            onAfterSubmit={handleClose}
            customButtons={<FormButtons handleCancelClick={handleClose} />}
        >
            <Field
                name="message"
                component={FinalFormInput}
                label={intl.formatMessage({ id: "reviermanager.devices.form.activityLog.message", defaultMessage: "Notiz" })}
                rows={4}
                multiline
                fullWidth
                required
            />
        </Form>
    );
};
export default AddForm;
